import {
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_BY_ID_SUCCESS,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_ERROR,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: {},
  dataById: null,
  list: [],
  error: {},
  errorList: {},
  status: statuslist.idle,
}

const ProductCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_CATEGORY_BY_ID_SUCCESS:
      return {
        ...state,
        dataById: action.payload,
      }
    case GET_CATEGORY_ERROR:
      return {
        ...state,
        data: {},
        error: action.payload?.data,
        status: statuslist.error,
      }
    case GET_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_CATEGORY_LIST_ERROR:
      return {
        ...state,
        list: {},
        errorList: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default ProductCategory
